import styles from '../components/style.module.scss'
import { useState } from 'react';
import Game from '../components/TopGames/Game';
import Modal from '../components/modal/Modal';
import img1 from '../img/Fallout.jpg'
import img2 from '../img/Inside.jpg'
import img3 from '../img/ghostoftsushima.jpg'
import img4 from '../img/Destiny2.jpeg'
import img5 from '../img/gta5.png'
import img6 from '../img/border-lands.jpg'
import img7 from '../img/kamla.jpg'
import img8 from '../img/1.jpg'
import Cube from '../components/Cube';
import PageTransition from '../components/PageTransition';

const games = [
  {
    title: "Fallout",
    src: img1,
    color: "#1b2838"
  },
  {
    title: "Insider",
    src: img2,
    color:  "#1b2838",
    
  },
  {
    title: "Ghost Of Tsushima",
    src: img3,
    color:  "#1b2838"
  },
  {
    title: "Destiny 2",
    src: img4,
    color:  "#1b2838"
  },
  {
    title: "GTA 5",
    src: img5,
    color:  "#1b2838"
  },
  {
    title: "Border Lands",
    src: img6,
    color:  "#1b2838"
  },
  {
    title: "Kamla",
    src: img7,
    color:  "#1b2838"
  },
  {
    title: "Call Of Duty",
    src: img8,
    color:  "#1b2838"
  },
];

export default function Games() {

  const [modal, setModal] = useState({active: false, index: 0})

  return (
    <>
    <PageTransition>
      <main className={styles.main2}>
        <div className={styles.body}>
          {
            games.map( (game, index) => {
              return <Game index={index} title={game.title} setModal={setModal} key={index}/>
            })
          }
        </div>
        <Modal modal={modal} games={games}/>

      
      </main>
        <Cube />
    </PageTransition>
    </>
  )
}